import api from "./api";
import { toast } from "sonner";

/** Download a binary file from the API and trigger a save dialog. */
export async function downloadFile(path, filename, params = {}) {
    try {
        const res = await api.get(path, { params, responseType: "blob" });
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        toast.success(`${filename} downloaded`);
    } catch (e) {
        toast.error(e?.response?.data?.detail || `Failed to download ${filename}`);
    }
}
